{
  "wallops-cdas": {
    "buildingId": 524425247,
    "center": [
      132.18301765171614,
      -11.904830990600843
    ],
    "rotation": -0.0,
    "width": 22.14,
    "depth": 13.12
  },
  "suitland": {
    "buildingId": 1497745495,
    "center": [
      -46.35141633468588,
      28.204244197363227
    ],
    "rotation": -0.008726646259971648,
    "width": 25.84,
    "depth": 16.32
  }
}
